const $slider_node_type3 = $(".js-slider-type3"),
    $current_node = $(".js-slider-current"),
    $total_node = $(".js-slider-total");

if($slider_node_type3.length){

    $slider_node_type3.on("initialized.owl.carousel", function(el) {

        let total =  el.item.count;
        $total_node.text(total);

    }).owlCarousel({
        loop:true,
        margin:24,
        nav: true,
        items: 1,
        smartSpeed: 1000,
        responsive: {
            0 : {
                navText: ["<svg><use href='#arrow-left'></use></svg>",
                    "<svg><use href='#arrow-right'></use></svg>"],
                dots: true,
            },
            768: {
                navText: ["<svg><use href='#arrow-left-long'></use></svg>",
                    "<svg><use href='#arrow-right-long'></use></svg>"],
                dots: false,
            },
        },

    }).on("changed.owl.carousel", function() {
        changeProgress();
    });
}

function changeProgress(){

    setTimeout(function(){
        let current = $slider_node_type3.find(".owl-item.active").find(".item").data("index");

        $current_node.text(current);
    },0);
}
